import * as React from "react"
import { cn } from "../utils/cn"

export interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
    size?: "sm" | "md" | "lg"
}

const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(
    ({ className, size = "md", ...props }, ref) => {
        const sizeClasses = {
            sm: "h-4 w-4 border-2",
            md: "h-8 w-8 border-2",
            lg: "h-12 w-12 border-[3px]",
        }

        return (
            <div
                ref={ref}
                role="status"
                aria-label="Loading"
                className={cn(
                    "inline-block animate-spin rounded-full border-current border-t-transparent text-ink",
                    sizeClasses[size],
                    size === "md" && "shadow-brutal-sm",
                    size === "lg" && "shadow-brutal-sm",
                    className
                )}
                {...props}
            >
                <span className="sr-only">Loading</span>
            </div>
        )
    }
)
Spinner.displayName = "Spinner"

export { Spinner }
